import React from 'react';
import Dict from 'dict-lib';
import ReactDom from 'react-dom';
import {getLexemeProperties} from './../../LexemePage';
import {Grid, Row, InputGroup, FormControl, Button, Col} from 'react-bootstrap';
import {LexemeEditingLevel, LexemeUtilities, translate} from './../LexemeHelper';
import {addNewPoly} from './EntryActions';
import {LanguageTreeViewPlus, LexemeNavigator, SCSubmitButton} from './../../../../dict-components/components';
import './../../../../_css/lexeme.css';
import './../root-entry/RootEntry.css';
import BUtils from './../../../../utilities/BaseUtilities';
import {Notifications} from "../../../../utilities/DictUtilities";

export class EntryTransformToPoly extends React.Component {

    constructor(props) {
        super(props);


        this.state = {
            polyForm: props.item.title.entry_form,
            editing: false,
            errorMessage: '',
            notValidMessage: ''
        };
    }

    componentWillMount() {
        if (this.props.item.polyrhematics.length > 0) {
            this.setState({notValidMessage: Dict.t('MULTIWORD_HAS_POLY')})
        }
    }

    _handleNewPolyForm(evt) {
        var editing = true;
        var polyForm = evt.target.value;
        this.setState({polyForm, editing});
    }

    _performTransform() {

        Notifications.showModalSpinner(Dict.t('TRANSFORM_PROGRESS'), '');
        var polyForm = LexemeUtilities.encodeUrl(this.state.polyForm);
        Dict.call('/entry/transformInPoly/' + '/' + this.props.context.rootEntryId + '/' + polyForm + '/' + this.state.selectableItem.id + '/').then(resultTr => {

            setTimeout(() => {
                Notifications.closeModalSpinner();
                const exPolyId = this.props.context.rootEntryId;

                document.getElementById('tab-close-' + exPolyId).click();

                const dictType = undefined;
                const pageStatus = this.props.context.pageStatus;
                const entryId = this.state.selectableItem.id;

                Dict.call('/page/getLexemePageData/' + entryId + '/' + dictType + '/').then(result => {
                    LexemeUtilities.openLexemePage(result.id, result.rootEntryId, true, pageStatus, result.entryForm, dictType, result.entryAbstr, result.language, result.languageCode, undefined,() => {
                        document.getElementById('div-poly-' + exPolyId).scrollIntoView({behavior: "smooth"});
                        LexemeUtilities.performHighlight('div-poly-', exPolyId);
                    });
                });
            }, 2000);
        });
    }

    _checkPolyValid(selectableItem) {
        if (selectableItem !== "") {
            var polyForm = LexemeUtilities.encodeUrl(this.state.polyForm);
            Dict.call('/entry/validateMultiwordtoToPolyInLexeme/' + polyForm + '/' + selectableItem.id + '/').then((result) => {
                const editing = false;
                if (result.result === 'OK') {
                    this.setState({editing, errorMessage: ''});
                } else {
                    this.setState({editing, errorMessage: result.result});
                }
            });
        } else {
            ReactDom.render('', document.getElementById('div-message-transf-in-poly'));
        }
    }

    render() {

        const hasSelectedItem = typeof this.state.selectableItem !== 'undefined' && this.state.selectableItem !== '';

        return <Grid className={'grid-poly-add'} fluid>
            {this.state.notValidMessage === '' ? <>
                    <Col lg={7} md={7} className={'div-multiword-transf-in-poly-navigator'}>
                        <div className={'div-container-lexeme-navigator-transf-in-poly'}>
                            <LexemeNavigator pageStatus={LexemeEditingLevel.READ_ONLY_CREATE}
                                             activeCreate={true}
                                             context={this.props.context}
                                             callbackParent={(selectableItem) => {
                                                 this.setState({selectableItem});
                                                 this._checkPolyValid(selectableItem);
                                             }}/>
                        </div>
                    </Col>
                    <Col lg={5} md={5} className={'div-multiword-transf-in-poly'}>
                        {hasSelectedItem ?
                            <FormControl type="text" placeholder={Dict.t('ENTRY_FORM') + "..."}
                                         value={this.state.polyForm}
                                         onChange={(evt) => this._handleNewPolyForm(evt)}
                                         onKeyUp={(evt) => {
                                             if (evt.keyCode === 13) {
                                                 this._checkPolyValid(this.state.selectableItem);
                                             }
                                         }}
                            /> : ''}
                        {/*hasSelectedItem &&*/ !this.state.editing ?
                            <div id={'div-message-transf-in-poly'} className={'div-message-transf-in-poly'}>
                                {this.state.errorMessage === '' ? <Row
                                    className={BUtils.joinClasses('div-message-transf-in-poly__button')}>
                                    <Button bsStyle="success" onClick={() => {
                                        this._performTransform();
                                    }
                                    }>{Dict.t('TRANSFORM')}</Button>
                                </Row> : <Row
                                    className={'div-message-transf-in-poly__msg__error'}>{Dict.t(this.state.errorMessage)}</Row>}
                            </div> : ''}
                    </Col></> :
                <Row
                    className={'div-message-transf-in-poly__msg__error'}>{this.state.notValidMessage}</Row>}
        </Grid>
    }
}